import {Sender} from 'xstate';
import {Navigator} from '@practicegenius/register-account/src/data/navigator';
import {NavigationEventSchema} from '@practicegenius/domain/src/machines/events';
import {useBrowserNavigationListener} from '@practicegenius/domain/src/machines/useBrowserNavigationListener';
import {HistoryNavigator} from '../../apps/register-account/HistoryNavigator';

export const useHistoryRouter = (
  nav: Navigator,
  send: Sender<NavigationEventSchema>
) => {
  const navigator = nav as HistoryNavigator;

  return useBrowserNavigationListener(navigator.history, send);
};
